import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { IntentBehaviorProvider } from 'seagull';
import { useStore } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export default function SeagullIntentBehaviorProvider(props) {
    const { getIntentBehavior, children } = props;
    const userRole = useStore(selectors.user.role);
    const { ENABLE_KILL_ACCOUNTANT_ACCESS_FE } = useFeatureFlags();
    const isViewModeFromStore = useStore(selectors.isViewMode);
    const isViewMode = !!ENABLE_KILL_ACCOUNTANT_ACCESS_FE && isViewModeFromStore;
    const { t: acTexts } = useLocaleKeys('components.accessControl');
    const intentBehavior = useMemo(()=>getIntentBehavior(userRole, {
            isViewMode,
            tooltips: acTexts
        }), [
        userRole,
        isViewMode,
        acTexts,
        getIntentBehavior
    ]);
    return /*#__PURE__*/ _jsx(IntentBehaviorProvider, {
        value: intentBehavior,
        children: children
    });
}
